const HTML_TAGS_DEFAULT_REGEX = /(\<(\/?[^>]+)>)/gi;
const DEFAULT_REPLACE_VALUE = '';

export const stripTags = (
  subject: string,
  replacement = DEFAULT_REPLACE_VALUE
): string => subject.replace(HTML_TAGS_DEFAULT_REGEX, replacement);
